import * as React from 'react';
import { BaseSpecialBoxProps } from './specialbox.interface';
import Exception from '@/components/base/exception';
import Placeholder from '@/components/base/placeholder';
import Loading from '@/components/base/loading';
import { Box } from '@mui/material';

export const SpecialBoxDefault: React.FC<BaseSpecialBoxProps> = (
  props: BaseSpecialBoxProps
) => {
  const {
    component,
    placeholder,
    placeholderTitle,
    placeholderSubtitle,
    placeholderNode: PlaceholderNode,
    loading,
    loadingTitle,
    loadingSubtitle,
    loadingNode: LoadingNode,
    error,
    errorTitle,
    errorSubtitle,
    errorNode: ErrorNode,
  } = props;

  const rootSx = [...(Array.isArray(props.sx) ? props.sx : [props.sx])];

  const Tag = component || 'div';

  return (
    <Box sx={rootSx}>
      <Tag>
        {loading &&
          (LoadingNode ? (
            LoadingNode
          ) : (
            <Loading title={loadingTitle} subtitle={loadingSubtitle} />
          ))}
        {error &&
          (ErrorNode ? (
            ErrorNode
          ) : (
            <Exception title={errorTitle} subtitle={errorSubtitle} />
          ))}
        {placeholder &&
          !error &&
          !loading &&
          (PlaceholderNode ? (
            PlaceholderNode
          ) : (
            <Placeholder
              title={placeholderTitle}
              subtitle={placeholderSubtitle}
            />
          ))}
      </Tag>
    </Box>
  );
};
